export const STATUS_TYPE = {
  '0': { text: '失败', color: 'danger' },
  '1': { text: '成功', color: 'success' },
  '-1': { text: '进行中', color: 'info' },
  '-2': { text: '审核中', color: 'primary' }
};

export const PAGINATION = {
  page: 1,
  size: 20
};
